import React, { useMemo } from "react";
import { Images } from "../../helper/images";
import TimelineChart from "../../component/flat-dot";
import { getStorageData, setStorageData } from "../../service/storage.service";
import { Constant, EVALAUTION_STAGES } from "../../helper/constant";

export const TaskStatus = {
    NotStarted: 'Not Started',
    PartiallyImplemented: 'Partially Implemented',
    FullyImplemented: 'Fully Implemented'
}
const AIEvaluationTable = ({ freeze, timeline = false, analyze = false, evaluate = false, tableData }) => {

    const disabledClass = 'cell-disabled';
    const fullImplemented = 'fully-implemented-mark';
    const partiallyImplemented = 'partially-implemented-mark';
    const notStarted = 'not-started-mark';

    const renderTableSteps = () => {
        return (
            <tr>
                <th className="ai-th"></th>
                <th className="ai-th"><span>1</span> Planning</th>
                <th className="ai-th"><span>2</span> Experimenting</th>
                <th className="ai-th"><span>3</span> Stabilization</th>
                <th className="ai-th"><span>4</span> Scaling</th>
                <th className="ai-th"><span>5</span> Leading</th>
                <th className="ai-th"></th>
            </tr>
        )
    }

    const renderTableSeparator = () => {
        return (
            <tr>
                <th></th>
                <th ><span className="p-2 tabel-line-text tableline-left-arrow">Initial activities</span></th>
                <th></th>
                <th></th>
                <th></th>
                <th className="text-right"><span className="p-2 tableline-right-arrow tabel-line-text text-right">Advanceed activities</span></th>
            </tr>
        )
    }

    const handleDotChange = (rowIndex, dotIndex, newValue) => {
        if (rowIndex) {
            const data = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
            data[rowIndex] = newValue;
            setStorageData(Constant.STORAGE_KEYS.TARGET_RANGE, data);
        }
    };


    const renderTimeChart = (data, reference) => {
        return (
            <TimelineChart data={data} onDotChange={handleDotChange} reference={reference} freeze={freeze} />
        )
    }

    const renderAIStrategy = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[0].current_range, striped: false, color: 'ai-strategy-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_STRATEGY] || 100, striped: true, color: 'ai-strategy-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header ">
                    <div className="row-header-wrap ai-strategy">
                        <div><img src={Images.aiStrategy} alt="AI Strategy" /></div>
                        <div>AI Strategy</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_STRATEGY)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(0, Constant.AI_STRATEGY[0], 'row-1-part-1')}
                        {renderTableCellContent(0, Constant.AI_STRATEGY[1], 'row-1-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(0, Constant.AI_STRATEGY[2], 'row-1-part-1')}
                        {renderTableCellContent(0, Constant.AI_STRATEGY[3], 'row-1-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(0, Constant.AI_STRATEGY[4], 'row-1-part-1')}
                        {renderTableCellContent(0, Constant.AI_STRATEGY[5], 'row-1-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(0, Constant.AI_STRATEGY[6], 'row-1-part-1')}
                        {renderTableCellContent(0, Constant.AI_STRATEGY[7], 'row-1-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(0, Constant.AI_STRATEGY[8], 'row-1-part-1')}
                    </td>
                </>}
            </tr>
        )
    }

    const getTaskStatus = (status) => {
        if (status === TaskStatus.PartiallyImplemented)
            return <img src={Images.inProgress} alt="in-progress" className="ai-task-status" />
        if (status === TaskStatus.FullyImplemented)
            return <img src={Images.done} alt="done" className="ai-task-status" />
    }

    const renderTableCellContent = (index, key, classess) => {
        const content = tableData && tableData && tableData[index] ? tableData && tableData[index].stages[key] : {};
        return (
            <div
                className={`d-flex justify-content-between gap-1 ${classess} ${evaluate ? (content?.show ? disabledClass : '') : ''}`}>
                <p className="p-0 m-0">{key}</p>
                {analyze && getTaskStatus(content.current_activity)}
            </div>
        )
    }

    const renderAIValue = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[1].current_range, striped: false, color: 'ai-value-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_VALUE] || 100, striped: true, color: 'ai-value-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-value">
                        <div><img src={Images.aiValue} alt="AI Value" /></div>
                        <div>AI Value</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_VALUE)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(1, Constant.AI_VALUE[0], 'row-2-part-1')}
                        {renderTableCellContent(1, Constant.AI_VALUE[1], 'row-2-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(1, Constant.AI_VALUE[2], 'row-2-part-1')}
                        {renderTableCellContent(1, Constant.AI_VALUE[3], 'row-2-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(1, Constant.AI_VALUE[4], 'row-2-part-1')}
                        {renderTableCellContent(1, Constant.AI_VALUE[5], 'row-2-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(1, Constant.AI_VALUE[6], 'row-2-part-1')}
                        {renderTableCellContent(1, Constant.AI_VALUE[7], 'row-2-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(1, Constant.AI_VALUE[8], 'row-2-part-1')}
                        {renderTableCellContent(1, Constant.AI_VALUE[9], 'row-2-part-2')}
                    </td>
                </>
                }
            </tr>
        )
    }

    const renderAIOrganization = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[2].current_range, striped: false, color: 'ai-organization-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_ORGANISATION] || 100, striped: true, color: 'ai-organization-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-org">
                        <div><img src={Images.aiOrganization} alt="AI Organization" /></div>
                        <div>AI Organization</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_ORGANISATION)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[0], 'row-3-part-1')}
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[1], 'row-3-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[2], 'row-3-part-1')}
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[3], 'row-3-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[4], 'row-3-part-1')}
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[5], 'row-3-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(2, Constant.AI_ORGANISATION[6], 'row-3-part-1 ')}
                    </td>
                    <td className="cell "></td>
                </>
                }
            </tr>
        )
    }

    const renderAIPeopleAndCulture = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[3].current_range, striped: false, color: 'ai-people-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_PEOPLE_AND_CULTURE] || 100, striped: true, color: 'ai-people-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-people">
                        <div><img src={Images.aiPeople} alt="AI People" /></div>
                        <div>AI People and Culture</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_PEOPLE_AND_CULTURE)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[0], 'row-4-part-1')}
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[1], 'row-4-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[2], 'row-4-part-1')}
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[3], 'row-4-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[4], 'row-4-part-1')}
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[5], 'row-4-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[6], 'row-4-part-1')}
                        {renderTableCellContent(3, Constant.AI_PEOPLE_AND_CULTURE[7], 'row-4-part-2')}
                    </td>
                    <td className="cell ">
                        <div className="row-4-part-11"></div>
                    </td>
                </>
                }
            </tr>
        )
    }

    const renderAIGovernance = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[4].current_range, striped: false, color: 'ai-governance-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_GOVERNANCE] || 100, striped: true, color: 'ai-governance-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-governance">
                        <div><img src={Images.aiGovernance} alt="AI Governance" /></div>
                        <div>AI Governance</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_GOVERNANCE)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[0], 'row-5-part-1')}
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[1], 'row-5-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[2], 'row-5-part-1')}
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[3], 'row-5-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[4], 'row-5-part-1')}
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[5], 'row-5-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[6], 'row-5-part-1')}
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[7], 'row-5-part-2')}
                    </td>
                    <td className="cell ">
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[8], 'row-5-part-1')}
                        {renderTableCellContent(4, Constant.AI_GOVERNANCE[9], 'row-5-part-2')}

                    </td>
                </>}
            </tr>
        )
    }

    const renderAIEngineering = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[5].current_range, striped: false, color: 'ai-engineering-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_ENGINEERING] || 100, striped: true, color: 'ai-engineering-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-engineering">
                        <div><img src={Images.aiEngineering} alt="ai-engineering" /></div>
                        <div>AI Engineering</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_ENGINEERING)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[0], 'row-6-part-1')}
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[1], 'row-6-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[2], 'row-6-part-1')}
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[3], 'row-6-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[4], 'row-6-part-1')}
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[5], 'row-6-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[6], 'row-6-part-1')}
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[7], 'row-6-part-2')}
                    </td>
                    <td className="cell ">
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[8], 'row-6-part-1')}
                        {renderTableCellContent(5, Constant.AI_ENGINEERING[9], 'row-6-part-2')}
                    </td>
                </>}

            </tr>
        )
    }

    const renderAIData = () => {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        const dots = [{
            dots: [
                { position: tableData && tableData[6].current_range, striped: false, color: 'ai-data-dot' },
                { position: target_range[EVALAUTION_STAGES.AI_DATA] || 100, striped: true, color: 'ai-data-dot' }
            ]
        }];
        return (
            <tr>
                <td className="row-header">
                    <div className="row-header-wrap ai-data">
                        <div><img src={Images.aiData} alt="ai-data" /></div>
                        <div>AI Data</div>
                    </div>
                </td>
                {timeline && <td colSpan={5} style={{ verticalAlign: 'middle' }}>
                    {renderTimeChart(dots, EVALAUTION_STAGES.AI_DATA)}
                </td>
                }
                {!timeline && <>
                    <td className="cell">
                        {renderTableCellContent(6, Constant.AI_DATA[0], 'row-7-part-1')}
                        {renderTableCellContent(6, Constant.AI_DATA[1], 'row-7-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(6, Constant.AI_DATA[2], 'row-7-part-1')}
                        {renderTableCellContent(6, Constant.AI_DATA[3], 'row-7-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(6, Constant.AI_DATA[4], 'row-7-part-1')}
                        {renderTableCellContent(6, Constant.AI_DATA[5], 'row-7-part-2')}
                    </td>
                    <td className="cell">
                        {renderTableCellContent(6, Constant.AI_DATA[6], 'row-7-part-1')}
                        {renderTableCellContent(6, Constant.AI_DATA[7], 'row-7-part-2')}
                    </td>
                    <td className="cell ">
                        {renderTableCellContent(6, Constant.AI_DATA[8], 'row-7-part-1')}
                    </td>
                </>}
            </tr>
        )
    }

    const renderEvaluationTable = () => {

        return (
            <table className="ai-table">
                <thead>{renderTableSteps()}</thead>
                <tbody>
                    {/* <!-- Row 1: Strategy --> */}
                    {renderAIStrategy()}
                    {/* <!-- Row 2: Value --> */}
                    {renderAIValue()}
                    {/* <!-- Row 3: Organization --> */}
                    {renderAIOrganization()}
                    {/* <!-- Row 4: People & Culture --> */}
                    {renderAIPeopleAndCulture()}
                    {/* <!-- Row 5: Governance --> */}
                    {renderAIGovernance()}
                    {/* <!-- Row 6: Engineering --> */}
                    {renderAIEngineering()}
                    {/* <!-- Row 7: Data --> */}
                    {renderAIData()}
                </tbody>
            </table>
        )
    }

    const render = () => {
        return (
            <div className="ai-table-wrapper mt-4">
                {renderEvaluationTable()}
            </div>
        );
    }

    return render();
}

export default AIEvaluationTable;